module.exports = __webpack_public_path__ + "static/media/odonto_2.6d98994b.jpg";